var map = {
	"./CommentCount.importable": [
		2330,
		331,
		327,
		330
	],
	"./DiscussionContainer.importable": [
		5075,
		331,
		327,
		760,
		893,
		75
	],
	"./EditionDropdown.importable": [
		6965,
		331,
		965
	],
	"./GetMatchStats.importable": [
		3639,
		331,
		327,
		639
	],
	"./InstagramBlockComponent.importable": [
		343,
		331,
		760,
		343
	],
	"./Links.importable": [
		1924,
		331,
		327,
		924
	],
	"./MostViewedRightWrapper.importable": [
		3764,
		331,
		327,
		195,
		764
	],
	"./RichLinkComponent.importable": [
		1126,
		331,
		327,
		126
	],
	"./SpotifyBlockComponent.importable": [
		7597,
		331,
		760,
		597
	],
	"./SubNav.importable": [
		6348,
		331,
		348
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 8602;
module.exports = webpackAsyncContext;